import { useState } from "react";
import {  ArrowUpRight } from "lucide-react";
import { SupportCancel, SupportView, WhatsappIcons } from "../assets/icon";

const WHATSAPP_NUMBER = "2348033603297"; 
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`;

const WhatsAppSupport = () => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <>
      {/* Open Button */}
      {isOpen && (
        <button
          onClick={() => setIsOpen(false)}
          className="fixed bottom-6 right-6 z-50 hover:scale-105 transition"
        >
          <SupportView />
        </button>
      )}

      {/* Chat Widget */}
      {!isOpen && (
        <div className="fixed bottom-6 right-6 z-50 flex items-center gap-3">
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-black text-white px-5 py-3 rounded-full shadow-lg hover:opacity-90 transition"
          >
        <WhatsappIcons />
            <span className="font-semibold text-[16px]">Chat With Us</span>
            <ArrowUpRight size={18} />
          </a>

          <button
            onClick={() => setIsOpen(true)}
            className="hover:scale-105 transition"
          >
            <SupportCancel />
          </button>
        </div>
      )}
    </>
  );
};

export default WhatsAppSupport;
